import { ActionHandler } from "@pageDefinitions/actions";
import { onStartSurvey } from "@pageDefinitions/actions/survey/onStartSurvey";
import { resolveSurveyPage } from "@pageDefinitions/actions/survey/cancellationSurveysActions";
import getStore from "@utils/redux/store";
import { resetCurrentAnswers } from "@utils/redux/slices/currentAnswers";
import { trackCurrentTierEvent } from "@utils/counterOffer";

export const onStartMedDowngradeSurvey: ActionHandler = (actionConfig) => {
  const resolvedConfig = resolveSurveyPage(actionConfig);
  onStartSurvey(resolvedConfig);
  const store = getStore();

  store.dispatch(
    resetCurrentAnswers({
      namespace: resolvedConfig.surveyNameSpace,
      answers: {},
    })
  );

  trackCurrentTierEvent();
};
